import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import PeopleContent from '../components/PeopleContent'; 
 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import ExploreMore from '../components/ExploreMore'; 
import GetInTouch from '../components/GetInTouch'; 
import { Helmet } from "react-helmet";
import {  base_url} from '../common/Constants';
 
class People extends React.Component{
 
    render()
    {

        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
       
        return (
            <div className="page-wrapper">
                <Header/> 
                <Helmet>
                    <title>{metas[3].title}</title>  
                    <meta name="description" content={metas[3].meta_description} />
                    <meta name="keywords" content={metas[3].meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'clients'} />
                </Helmet>
                <PageHeader title="People"/>
                <PeopleContent content={JSON.parse(localStorage.getItem("content"))} clients={JSON.parse(localStorage.getItem("clients"))} />  
                 <ExploreMore content={JSON.parse(localStorage.getItem("content"))}/>
                 <GetInTouch content={JSON.parse(localStorage.getItem("content"))}/>  
                <Footer/>
            </div>
       
        )
    }

}
export default People;